import { apiUrl } from "../api/endpoints";
import React, { useEffect, useState, useContext, Fragment, useCallback, useMemo, useRef } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import useWindowDimensions from "../hooks/useWindowDimensions";
import axios from 'axios';
import './details.css';
import './edit.css';
import '../Components/modal.css';
import './TemplateDetails.css';
import { useAuth } from '../hooks/AuthProvider';
import Spinner from '../Components/Spinner';

import { LanguageContext } from '../context/LanguageContext';
import templateTranslations from '../languages/template.json';
import webDashboardTranslations from '../languages/webDashboard.json';

import Alert from '../Components/Alert';
import AppDialog from '../Components/AppDialog';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { getErrorMessage } from '../utils/errorUtils';
import {
    DATASTREAM_MIN_MAX_ABS_LIMIT,
    normalizeTemplateDatastreamCollection,
    validateDatastreamCollection,
} from '../utils/datastreamValidation';
import {
    formatDatastreamIdForDisplay,
    getNextTemporaryDatastreamId,
} from '../utils/datastreamIds';
import TemplateAddDashboardPopup from './TemplateDetails/TemplateAddDashboardPopup';
import TemplateBooleanToggleCell from './TemplateDetails/TemplateBooleanToggleCell';
import TemplateColorSwatchCell from './TemplateDetails/TemplateColorSwatchCell';
import TemplateDashboardTabPanel from './TemplateDetails/TemplateDashboardTabPanel';
import TemplateDatastreamsTab from './TemplateDetails/TemplateDatastreamsTab';
import TemplateDetailsControlRail from './TemplateDetails/TemplateDetailsControlRail';
import TemplateDetailsContentShell from './TemplateDetails/TemplateDetailsContentShell';
import TemplateEditTabRolePopup from './TemplateDetails/TemplateEditTabRolePopup';
import TemplateEditorModals from './TemplateDetails/TemplateEditorModals';
import TemplateEventsTab from './TemplateDetails/TemplateEventsTab';
import TemplateExampleDialogs from './TemplateDetails/TemplateExampleDialogs';
import TemplateFallbackTabContent from './TemplateDetails/TemplateFallbackTabContent';
import {
    buildTemplateSelectedRowActions,
} from './TemplateDetails/TemplateGridActions';
import TemplateHomeTab from './TemplateDetails/TemplateHomeTab';
import {
    buildDatastreamTypeChangeConfirmation,
    applyEditedDashboardTabRoles,
    buildTemplateDashboardViewportState,
    buildTemplateDetailsTabs,
    buildDatastreamValidationOptions,
    buildDisabledActionsColumn,
    buildTemplateFileActionMessages,
    buildTemplateUpdatePayloadBase,
    buildTemplateExampleSelectStyles,
    checkTabPermission,
    diffRemovedFiles,
    findDatastreamTypeChangesForConfirmation,
    hasDatastreamPatchChanges,
    hydrateFetchedTemplateDetails,
    normalizeExampleNameValue,
    parseTemplateDetailsUrlIndex,
    pinCategories,
    sortTemplateExamples,
    getOriginDevicePath,
    templateDetailsPagingOptions,
    templateDetailsTableColors,
    toggleDashboardAccessRoleState,
} from './TemplateDetails/templateDetailsHelpers';
import {
    buildDuplicateDatastreamDraft,
    buildDatastreamBulkDeleteDetails,
    buildDatastreamBulkDeleteEvaluationData,
    buildDatastreamEditState,
    buildEventEditState,
    removeDatastreamById,
    removeEvaluationRangesByDatastreamId,
    resolveDuplicateDatastreamSource,
} from './TemplateDetails/templateDatastreamHelpers';
import TemplateDeviceEvaluationModals from './TemplateDetails/TemplateDeviceEvaluationModals';
import {
    attachTemplateExampleToTemplate,
    createTemplateExampleFromTemplate,
    detachTemplateExampleFromTemplate,
    fetchTemplateExamples,
} from './TemplateDetails/templateExampleService';
import {
    deleteTemplateFile,
    deleteTemplateFilesBulk,
    cleanupOrphanedTemplateIcon,
    cleanupPreviousTemplateIcon,
    cleanupPreviousTemplateMapIcon,
    cleanupUploadedMapIconAfterFailure,
    saveTemplateFile,
    uploadTemplateWidgetFiles,
} from './TemplateDetails/templateFileService';
import { DatastreamsIcon, WebDashboardIcon, EventNotificationIcon, HomeIcon } from '../svg/TemplateIcons';
import { DeleteIcon, DuplicateIcon } from '../svg/UtilsIcons';
import {
    getEffectiveFixedWidthValue,
    normalizeWebDashboardTabs,
    WEB_DASHBOARD_LAYOUT_MODES,
} from '../utils/webDashboardLayout';
import {
    deleteStoredMapIcon,
    normalizeStoredIconPath,
    uploadTemplateMapIcon,
    validateMapIconFile,
} from '../utils/mapIconUpload';
import {
    DEFAULT_REPORT_PRIORITY_POLICY,
    normalizeReportPriorityPolicy,
} from '../utils/reportPriorityPolicy';

export const TemplateDetails = () => {
    const [initialTemplate, setInitialTemplate] = useState({});
 const deepClone = (obj) => JSON.parse(JSON.stringify(obj ?? {}));
    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { user, permissions } = useAuth();
    const userRole = user.role?.toLowerCase();
    const dims = useWindowDimensions();
    const [loading, setLoading] = useState(true);
    const [settings, setSettings] = useState(false);
    const [previousIcon, setPreviousIcon] = useState('');
    const [pendingMapIconFile, setPendingMapIconFile] = useState(null);
    const [pendingMapIconPreviewUrl, setPendingMapIconPreviewUrl] = useState('');
    const [mapIconMarkedForRemoval, setMapIconMarkedForRemoval] = useState(false);
    const origin = searchParams.get('origin');
    const originDeviceId = searchParams.get('deviceId');
    const [isEvalModalOpen, setIsEvalModalOpen] = useState(false); 
    const [edit, setEdit] = useState({
        edit: false,
        tempId: id,
        dataId: 0,
        mode: searchParams.get('mode') || 'view', 
        editEvents: false,
        eventId: 0
    });
    const [tabsWidth, setTabsWidth] = useState(false);
    const [addDatastream, setAddDatastream] = useState({
        edit: false,
        pinCategory: '',
        addEvents: false,
        isNew: false
    });
    const [downloadReportState, setDownloadReportState] = useState({
        open: false,
        template: null
    });
    const [addDevice, setAddDevice] = useState(false);
    const [isHeaderActionsMenuOpen, setIsHeaderActionsMenuOpen] = useState(false);
    const [isMobileDetailsRailOpen, setIsMobileDetailsRailOpen] = useState(false);
    const [isCurrentDashboardFixedWidth, setIsCurrentDashboardFixedWidth] = useState(true);
    const [isFixedWidthToggleReady, setIsFixedWidthToggleReady] = useState(false);
    const [isMultiSelectEnabled, setIsMultiSelectEnabled] = useState(false);
    const [isMultiSelectToggleReady, setIsMultiSelectToggleReady] = useState(false);
    const [isDashboardExpanded, setIsDashboardExpanded] = useState(false);
    const [dashboardViewportHeight, setDashboardViewportHeight] = useState(null);
    const fixedWidthToggleHandlerRef = useRef(null);
    const multiSelectToggleHandlerRef = useRef(null);
    const dashboardBodyRef = useRef(null);
    const dashboardPanelRef = useRef(null);
    const dashboardViewportRef = useRef(null);
    const [details, setDetails] = useState(null);
    const [reportPriorityPolicy, setReportPriorityPolicy] = useState(DEFAULT_REPORT_PRIORITY_POLICY);
    const [reportPriorityChanges, setReportPriorityChanges] = useState([]);
    const [templateExamples, setTemplateExamples] = useState([]);
    const [hasLoadedTemplateExamples, setHasLoadedTemplateExamples] = useState(false);
    const [loadingTemplateExamples, setLoadingTemplateExamples] = useState(false);
    const [markAsExampleDialog, setMarkAsExampleDialog] = useState({
        open: false,
        exampleName: '',
        error: '',
        submitting: false,
    });
    const [attachExampleDialog, setAttachExampleDialog] = useState({
        open: false,
        selectedExampleId: null,
        error: '',
        submitting: false,
    });
    const headerActionsMenuRef = useRef(null);
    
    const [templateEvaluationData, setTemplateEvaluationData] = useState({ 
        evaluation_names: [], 
        datastream_ranges: [] 
    });


    const { lang } = useContext(LanguageContext);
    const t = templateTranslations[lang].TemplateDetails;
    const webDashboardT = webDashboardTranslations[lang]?.webDashboard || {};
    const isRtl = ['ar', 'ur'].includes(lang);
    const isCompactHeaderActions = dims.width <= 1280;
    const isMobileTemplateDetailsLayout = dims.width <= 768;

    const [alertState, setAlertState] = useState({
        open: false,
        message: '',
        type: 'info',
        position: isRtl ? 'left' : 'right',
    });

    const showAlert = useCallback((type, message) => {
        setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
    }, [setAlertState, isRtl]);

    useEffect(() => {
        let active = true;
        axios.get(apiUrl('configuration/public'), { params: { _: Date.now() } })
            .then((response) => {
                if (!active) return;
                setReportPriorityPolicy(
                    normalizeReportPriorityPolicy(response?.data?.data?.reportPriorityPolicy)
                );
            })
            .catch((error) => {
                console.warn('[TemplateDetails] Failed to load report priority policy; using shift.', error);
            });

        return () => {
            active = false;
        };
    }, [edit.mode]);

    const templateExampleSelectStyles = useMemo(buildTemplateExampleSelectStyles, []);

    const loadTemplateExamples = useCallback(async () => {
        if (loadingTemplateExamples) {
            return templateExamples;
        }

        setLoadingTemplateExamples(true);
        try {
            const examples = await fetchTemplateExamples();
            const sortedExamples = sortTemplateExamples(examples);
            setTemplateExamples(sortedExamples);
            setHasLoadedTemplateExamples(true);
            return sortedExamples;
        } catch (err) {
            console.error('[TemplateDetails] Failed to load template examples:', err);
            showAlert('error', t.markAsExampleLoadError || 'Failed to load template examples.');
            return [];
        } finally {
            setLoadingTemplateExamples(false);
        }
    }, [loadingTemplateExamples, showAlert, t.markAsExampleLoadError, templateExamples]);

    const resolverRef = useRef(null);
    const [dialog, setDialog] = useState({
        open: false,
        type: 'alert', // 'alert' | 'confirm'
        variant: 'info', // 'info' | 'danger' | 'error'
        icon: 'alert', // 'alert' | 'delete'
        title: '',
        message: '',
        confirmText: t.buttonOk || templateTranslations[lang].buttonOk || 'OK',
        cancelText: t.buttonCancel || templateTranslations[lang].buttonCancel || 'Cancel',
        showCancel: false,
    });

    const closeDialog = useCallback((result = false) => {
        setDialog(d => ({ ...d, open: false }));
        if (resolverRef.current) {
            resolverRef.current(result);
            resolverRef.current = null;
        }
    }, []);

    const alert = useCallback(
        (opts) =>
            new Promise(resolve => {
                resolverRef.current = resolve;

                setDialog({
                    open: true,
                    type: opts?.type || 'alert',
                    variant: opts?.variant || 'info',
                    icon: opts?.icon || 'alert',
                    title: opts?.title || '',
                    message: opts?.message || '',
                    confirmText: opts?.confirmText || t.buttonOk || templateTranslations[lang].buttonOk || 'OK',
                    cancelText: opts?.cancelText || t.buttonCancel || templateTranslations[lang].buttonCancel || 'Cancel',
                    showCancel: Boolean(opts?.showCancel),
                });
            }),
        [lang, t.buttonCancel, t.buttonOk],
    );

    const [allRoles, setAllRoles] = useState([]);
    
    const fetchRoles = useCallback(async () => {
        try {
            const res = await axios.get(apiUrl(`roles`));
            const roleNames = res.data.data.map(role => role.name.toLowerCase()); 
            setAllRoles(roleNames);
        } catch (err) {
            console.error("Failed to fetch roles:", err);
            showAlert('error', t.failedToLoadRoles || 'Failed to load roles for access control.');
            setAllRoles(['user', 'staff', 'owner', 'super']); 
        }
    }, [showAlert, setAllRoles, t.failedToLoadRoles]);
    useEffect(() => {
        fetchRoles();
    }, [fetchRoles]);

    useEffect(() => {
        if (!isCompactHeaderActions) {
            setIsHeaderActionsMenuOpen(false);
        }
    }, [isCompactHeaderActions]);

    useEffect(() => {
        if (!isMobileTemplateDetailsLayout) {
            setIsMobileDetailsRailOpen(false);
        }
    }, [isMobileTemplateDetailsLayout]);

    useEffect(() => {
        return () => {
            if (pendingMapIconPreviewUrl) {
                URL.revokeObjectURL(pendingMapIconPreviewUrl);
            }
        };
    }, [pendingMapIconPreviewUrl]);

    const clearPendingMapIconPreview = useCallback(() => {
        setPendingMapIconPreviewUrl((prev) => {
            if (prev) URL.revokeObjectURL(prev);
            return '';
        });
    }, []);

    const handleMapIconFileChange = useCallback(async (event) => {
        const file = event.target.files?.[0] || null;
        event.target.value = '';
        if (!file) return;

        try {
            await validateMapIconFile(file);
            clearPendingMapIconPreview();
            setPendingMapIconFile(file);
            setPendingMapIconPreviewUrl(URL.createObjectURL(file));
            setMapIconMarkedForRemoval(false);
        } catch (err) {
            showAlert('error', err.message || 'Invalid map icon file.');
        }
    }, [clearPendingMapIconPreview, showAlert]);

    const handleRemoveMapIcon = useCallback(() => {
        clearPendingMapIconPreview();
        setPendingMapIconFile(null);
        setMapIconMarkedForRemoval(true);
        setDetails((prev) => (prev ? { ...prev, map_icon: '' } : prev));
    }, [clearPendingMapIconPreview, setDetails]);

    useEffect(() => {
        if (!isHeaderActionsMenuOpen) return undefined;

        const handlePointerDown = (event) => {
            if (headerActionsMenuRef.current?.contains(event.target)) {
                return;
            }

            setIsHeaderActionsMenuOpen(false);
        };

        document.addEventListener('mousedown', handlePointerDown);
        return () => document.removeEventListener('mousedown', handlePointerDown);
    }, [isHeaderActionsMenuOpen]);

    const isDetailsRailExpanded = isMobileTemplateDetailsLayout || tabsWidth;


    const canEditTemplate = permissions['edit_templates'];
    const canDeleteTemplate = permissions['delete_templates'];
    const canAddTemplate = permissions['add_new_templates'];
    const canProvisionDevices = permissions['provision_new_devices'];
    const canViewTemplate = permissions['view_templates'];
    const canViewEvents = permissions['edit_templates'];
    const canEditEvent = permissions['edit_device_events'];
    const canDeleteEvent = permissions['delete_event'];
    const canViewDatastreams = permissions['edit_templates'];
    const canEditDatastream = permissions['edit_datastream'];
    const canDeleteDatastream = permissions['delete_datastream'];
    const canDownloadReports = permissions['download_dashboard_reports'];
    const canDownloadAiReports = permissions['download_ai_reports'];
    const canOpenReportDialog = true;
    const downloadReportActionLabel = canDownloadReports
        ? (t.downloadReport || t.download || 'Download Report')
        : canDownloadAiReports
            ? (t.downloadAiReport || 'Download AI Report')
            : (t.downloadReport || t.download || 'Download Report');
    const canAddTemplateExamples = permissions['add_template_examples'];
    const canManageTemplateExampleLinks = canEditTemplate && canAddTemplateExamples;

    const normalizedExistingExampleNames = useMemo(
        () =>
            new Set(
                templateExamples
                    .map((example) => normalizeExampleNameValue(example?.example_name))
                    .filter(Boolean)
            ),
        [templateExamples]
    );

    const normalizedDialogExampleName = useMemo(
        () => normalizeExampleNameValue(markAsExampleDialog.exampleName),
        [markAsExampleDialog.exampleName]
    );

    const isExampleNameDuplicate = useMemo(
        () =>
            Boolean(
                normalizedDialogExampleName &&
                    hasLoadedTemplateExamples &&
                    normalizedExistingExampleNames.has(normalizedDialogExampleName)
            ),
        [hasLoadedTemplateExamples, normalizedDialogExampleName, normalizedExistingExampleNames]
    );

    const openMarkAsExampleDialog = useCallback(async () => {
        if (!canAddTemplateExamples) {
            showAlert('error', t.markAsExamplePermissionError || 'You do not have permission to perform this action.');
            return;
        }

        if (!details?.id) {
            showAlert('warning', t.markAsExampleTemplateMissing || 'Template details are not available yet.');
            return;
        }

        if (edit.mode === 'edit') {
            showAlert('warning', t.markAsExampleApplyFirst || 'Apply or cancel your template changes before marking it as an example.');
            return;
        }

        setMarkAsExampleDialog({
            open: true,
            exampleName: String(details?.name || '').trim(),
            error: '',
            submitting: false,
        });

        if (!hasLoadedTemplateExamples && !loadingTemplateExamples) {
            await loadTemplateExamples();
        }
    }, [
        canAddTemplateExamples,
        details,
        edit.mode,
        hasLoadedTemplateExamples,
        loadTemplateExamples,
        loadingTemplateExamples,
        showAlert,
        t.markAsExampleApplyFirst,
        t.markAsExamplePermissionError,
        t.markAsExampleTemplateMissing,
    ]);

    const closeMarkAsExampleDialog = useCallback(() => {
        setMarkAsExampleDialog((prev) =>
            prev.submitting
                ? prev
                : {
                      open: false,
                      exampleName: '',
                      error: '',
                      submitting: false,
                  }
        );
    }, []);

    const handleMarkAsExampleNameChange = useCallback((event) => {
        const nextValue = event.target.value;
        setMarkAsExampleDialog((prev) => ({
            ...prev,
            exampleName: nextValue,
            error: '',
        }));
    }, []);

    const submitMarkAsExample = useCallback(async () => {
        if (!canAddTemplateExamples) {
            showAlert('error', t.markAsExamplePermissionError || 'You do not have permission to perform this action.');
            return;
        }

        if (!details?.id) {
            showAlert('warning', t.markAsExampleTemplateMissing || 'Template details are not available yet.');
            return;
        }

        const trimmedExampleName = String(markAsExampleDialog.exampleName || '').trim();
        if (!trimmedExampleName) {
            setMarkAsExampleDialog((prev) => ({
                ...prev,
                error: t.markAsExampleNameRequired || 'Example name is required.',
            }));
            return;
        }

        if (hasLoadedTemplateExamples && normalizedExistingExampleNames.has(normalizeExampleNameValue(trimmedExampleName))) {
            setMarkAsExampleDialog((prev) => ({
                ...prev,
                error: t.markAsExampleUnique || 'Example name must be unique.',
            }));
            return;
        }

        setMarkAsExampleDialog((prev) => ({
            ...prev,
            submitting: true,
            error: '',
        }));

        try {
            const res = await createTemplateExampleFromTemplate(details.id, trimmedExampleName);

            setTemplateExamples((prev) => {
                const next = prev.filter(
                    (example) =>
                        normalizeExampleNameValue(example?.example_name) !==
                        normalizeExampleNameValue(trimmedExampleName)
                );
                next.push(res.data.data);
                return sortTemplateExamples(next);
            });
            setHasLoadedTemplateExamples(true);
            setMarkAsExampleDialog({
                open: false,
                exampleName: '',
                error: '',
                submitting: false,
            });
            showAlert('success', res.data.message || (t.markAsExampleSuccess || 'Template example created successfully.'));
        } catch (err) {
            const errorMessage = getErrorMessage(err);
            setMarkAsExampleDialog((prev) => ({
                ...prev,
                submitting: false,
                error: errorMessage,
            }));
            showAlert('error', errorMessage);
        }
    }, [
        canAddTemplateExamples,
        details,
        hasLoadedTemplateExamples,
        markAsExampleDialog.exampleName,
        normalizedExistingExampleNames,
        showAlert,
        t.markAsExampleNameRequired,
        t.markAsExamplePermissionError,
        t.markAsExampleSuccess,
        t.markAsExampleTemplateMissing,
        t.markAsExampleUnique,
    ]);

    const isMarkAsExampleSubmitDisabled =
        markAsExampleDialog.submitting ||
        !String(markAsExampleDialog.exampleName || '').trim() ||
        isExampleNameDuplicate;

    const attachedTemplateExample = details?.templateExample || null;
    const attachExampleOptions = useMemo(
        () =>
            templateExamples.map((example) => ({
                value: example.template_example_id,
                label:
                    example.example_name ||
                    example.name ||
                    `#${example.template_example_id}`,
                example,
            })),
        [templateExamples]
    );
    const selectedAttachExampleOption = useMemo(
        () =>
            attachExampleOptions.find(
                (option) => Number(option.value) === Number(attachExampleDialog.selectedExampleId)
            ) || null,
        [attachExampleDialog.selectedExampleId, attachExampleOptions]
    );

    const openAttachExampleDialog = useCallback(async () => {
        if (!canManageTemplateExampleLinks) {
            showAlert(
                'error',
                t.attachExamplePermissionError ||
                    t.actionPermissionError ||
                    'You do not have permission to perform this action.'
            );
            return;
        }

        if (!details?.id) {
            showAlert(
                'warning',
                t.attachExampleTemplateMissing ||
                    t.markAsExampleTemplateMissing ||
                    'Template details are not available yet.'
            );
            return;
        }

        if (edit.mode === 'edit') {
            showAlert(
                'warning',
                t.attachExampleApplyFirst ||
                    t.markAsExampleApplyFirst ||
                    'Apply or cancel your template changes before changing the attached example.'
            );
            return;
        }

        if (!hasLoadedTemplateExamples && !loadingTemplateExamples) {
            await loadTemplateExamples();
        }

        setAttachExampleDialog({
            open: true,
            selectedExampleId:
                details?.template_example_id ??
                details?.templateExample?.template_example_id ??
                null,
            error: '',
            submitting: false,
        });
    }, [
        canManageTemplateExampleLinks,
        details,
        edit.mode,
        hasLoadedTemplateExamples,
        loadTemplateExamples,
        loadingTemplateExamples,
        showAlert,
        t.actionPermissionError,
        t.attachExampleApplyFirst,
        t.attachExamplePermissionError,
        t.attachExampleTemplateMissing,
        t.markAsExampleApplyFirst,
        t.markAsExampleTemplateMissing,
    ]);

    const closeAttachExampleDialog = useCallback(() => {
        setAttachExampleDialog((prev) =>
            prev.submitting
                ? prev
                : {
                      open: false,
                      selectedExampleId: null,
                      error: '',
                      submitting: false,
                  }
        );
    }, []);

    const handleAttachExampleSelection = useCallback((selectedOption) => {
        setAttachExampleDialog((prev) => ({
            ...prev,
            selectedExampleId: selectedOption ? selectedOption.value : null,
            error: '',
        }));
    }, []);

    const hydrateTemplateDetailsResponse = useCallback(
        (responseData, fallbackTemplate = details) => {
            const fallbackDevices = Array.isArray(fallbackTemplate?.templateDevices)
                ? fallbackTemplate.templateDevices
                : Array.isArray(fallbackTemplate?.devices)
                ? fallbackTemplate.devices
                : [];

            return {
                ...responseData,
                datastreams: normalizeTemplateDatastreamCollection(
                    typeof responseData.datastreams === 'string'
                        ? JSON.parse(responseData.datastreams)
                        : responseData.datastreams || []
                ),
                events: (
                    typeof responseData.events === 'string'
                        ? JSON.parse(responseData.events)
                        : responseData.events || []
                ).filter((event) => event),
                webdashboard: normalizeWebDashboardTabs(
                    typeof responseData.webdashboard === 'string'
                        ? JSON.parse(responseData.webdashboard)
                        : responseData.webdashboard || []
                ),
                mobdashboard: (
                    typeof responseData.mobdashboard === 'string'
                        ? JSON.parse(responseData.mobdashboard)
                        : responseData.mobdashboard || []
                ).filter((dashboard) => dashboard),
                templateDevices: Array.isArray(responseData.templateDevices)
                    ? responseData.templateDevices
                    : fallbackDevices,
                devices: Array.isArray(responseData.devices)
                    ? responseData.devices
                    : fallbackDevices,
                device_count:
                    typeof responseData.device_count === 'number'
                        ? responseData.device_count
                        : fallbackTemplate?.device_count,
            };
        },
        [details]
    );

    const submitAttachExample = useCallback(async () => {
        if (!canManageTemplateExampleLinks) {
            showAlert(
                'error',
                t.attachExamplePermissionError ||
                    t.actionPermissionError ||
                    'You do not have permission to perform this action.'
            );
            return;
        }

        if (!details?.id) {
            showAlert(
                'warning',
                t.attachExampleTemplateMissing ||
                    t.markAsExampleTemplateMissing ||
                    'Template details are not available yet.'
            );
            return;
        }

        if (!attachExampleDialog.selectedExampleId) {
            setAttachExampleDialog((prev) => ({
                ...prev,
                error: t.attachExampleRequired || 'Please select a template example.',
            }));
            return;
        }

        setAttachExampleDialog((prev) => ({
            ...prev,
            submitting: true,
            error: '',
        }));
        setLoading(true);

        try {
            const res = await attachTemplateExampleToTemplate(
                details.id,
                attachExampleDialog.selectedExampleId,
                t.unexpectedResponse
            );

            const responseData = res.data.data;
            const nextTemplate = hydrateTemplateDetailsResponse(responseData, details);
            const safeNextTemplate = deepClone(nextTemplate);

            setDetails(safeNextTemplate);
            setInitialTemplate(deepClone(safeNextTemplate));
            setTemplateEvaluationData(
                responseData.templateEvaluationData || {
                    evaluation_names: [],
                    datastream_ranges: [],
                }
            );
            setAttachExampleDialog({
                open: false,
                selectedExampleId: null,
                error: '',
                submitting: false,
            });
            showAlert(
                'success',
                res.data.message ||
                    t.attachExampleSuccess ||
                    'Template was attached to the selected example and synced successfully.'
            );
        } catch (err) {
            const errorMessage = getErrorMessage(err);
            setAttachExampleDialog((prev) => ({
                ...prev,
                submitting: false,
                error: errorMessage,
            }));
            showAlert('error', errorMessage);
        } finally {
            setLoading(false);
        }
    }, [
        attachExampleDialog.selectedExampleId,
        canManageTemplateExampleLinks,
        details,
        hydrateTemplateDetailsResponse,
        setLoading,
        showAlert,
        t.actionPermissionError,
        t.attachExamplePermissionError,
        t.attachExampleRequired,
        t.attachExampleSuccess,
        t.attachExampleTemplateMissing,
        t.markAsExampleTemplateMissing,
        t.unexpectedResponse,
    ]);

    const detachTemplateFromExample = useCallback(async () => {
        if (!canManageTemplateExampleLinks) {
            showAlert(
                'error',
                t.attachExamplePermissionError ||
                    t.actionPermissionError ||
                    'You do not have permission to perform this action.'
            );
            return;
        }

        if (!details?.id) {
            showAlert(
                'warning',
                t.attachExampleTemplateMissing ||
                    t.markAsExampleTemplateMissing ||
                    'Template details are not available yet.'
            );
            return;
        }

        if (edit.mode === 'edit') {
            showAlert(
                'warning',
                t.attachExampleApplyFirst ||
                    t.markAsExampleApplyFirst ||
                    'Apply or cancel your template changes before changing the attached example.'
            );
            return;
        }

        const exampleName =
            details?.templateExample?.example_name ||
            details?.templateExample?.name ||
            '';
        const confirmed = await alert({
            type: 'confirm',
            variant: 'info',
            icon: 'alert',
            title: t.detachExampleTitle || 'Detach from example',
            message:
                exampleName
                    ? (t.detachExampleConfirmMessageWithName ||
                          `Detach this template from "${exampleName}"? The current template data will stay as-is.`).replace(
                          '{name}',
                          exampleName
                      )
                    : t.detachExampleConfirmMessage ||
                      'Detach this template from its linked example? The current template data will stay as-is.',
            confirmText: t.detachExampleAction || t.detachExample || 'Detach',
            cancelText: t.cancel || 'Cancel',
            showCancel: true,
        });

        if (!confirmed) {
            return;
        }

        setLoading(true);

        try {
            const res = await detachTemplateExampleFromTemplate(details.id, t.unexpectedResponse);

            setDetails((prev) => ({
                ...prev,
                template_example_id: null,
                templateExample: null,
            }));
            setInitialTemplate((prev) => ({
                ...prev,
                template_example_id: null,
                templateExample: null,
            }));

            showAlert(
                'success',
                res.data.message ||
                    t.detachExampleSuccess ||
                    'Template was detached from the linked example. The current template data was kept unchanged.'
            );
        } catch (err) {
            const errorMessage = getErrorMessage(err);
            showAlert('error', errorMessage);
        } finally {
            setLoading(false);
        }
    }, [
        alert,
        canManageTemplateExampleLinks,
        details,
        edit.mode,
        setLoading,
        showAlert,
        t.actionPermissionError,
        t.attachExampleApplyFirst,
        t.attachExamplePermissionError,
        t.attachExampleTemplateMissing,
        t.cancel,
        t.detachExample,
        t.detachExampleAction,
        t.detachExampleConfirmMessage,
        t.detachExampleConfirmMessageWithName,
        t.detachExampleSuccess,
        t.detachExampleTitle,
        t.markAsExampleApplyFirst,
        t.markAsExampleTemplateMissing,
        t.unexpectedResponse,
    ]);

    const pagingoptions = templateDetailsPagingOptions;
    const colors = templateDetailsTableColors;

    const eventsFields = [
        (edit.mode === 'edit' && canDeleteEvent) ?
            {
                field: 'actions', headerName: t.column.actions, type: 'actions', width: 100,
                getActions: (params) => [
                    <GridActionsCellItem
                        key="delete"
                        icon={<DeleteIcon />}
                        showInMenu
                        label={t.delete}
                        onClick={() => setDetails(prev => ({
                            ...prev,
                            events: prev.events?.filter(ev => ev.id !== params.row.id)
                        }))}
                    />,
                ],
            } : buildDisabledActionsColumn(t.column.actions),
        { field: 'id', headerName: t.column.id, width: 100, align: 'left', headerAlign: 'left', type: 'number' },
        { field: 'name', headerName: t.column.name, width: 200, align: 'left', headerAlign: 'left' },
        { field: 'code', headerName: t.column.code, width: 200, align: 'left', headerAlign: 'left' },
        {
            field: 'color', headerName: t.column.color, align: 'center',
            headerAlign: 'center', renderCell: (params) => {
                return <TemplateColorSwatchCell color={params.row.color} />;
            },
        },
        { field: 'type', headerName: t.column.type, width: 200, align: 'left', headerAlign: 'left' },
        {
            field: 'notification', headerName: t.column.notification, width: 100, align: 'center',
            headerAlign: 'center', renderCell: (params) => {

                return <TemplateBooleanToggleCell checked={params.row.notification} inactiveColor={colors.cellColor} />;
            },
        },
        {
            field: 'condition', headerName: t.column.condition, width: 100, align: 'center',
            headerAlign: 'center', renderCell: (params) => {

                return <TemplateBooleanToggleCell checked={params.row.condition} inactiveColor={colors.cellColor} />;
            },
        },
        {
            field: 'action', headerName: t.column.action, width: 100, align: 'center',
            headerAlign: 'center', renderCell: (params) => {

                return <TemplateBooleanToggleCell checked={params.row.action} inactiveColor={colors.cellColor} />;
            },
        },
        
    ];

    const getNextDatastreamId = (list) => {
        return getNextTemporaryDatastreamId(list);
    };

    const duplicateGuardRef = useRef({ sourceId: null, ts: 0 });

    const handleDuplicateDatastream = (payloadOrId) => {
        try {
            const existing = (details.datastreams || []).filter(Boolean);

            const source = resolveDuplicateDatastreamSource(payloadOrId, existing);

            if (!source) return;

            const now = Date.now();
            if (
                duplicateGuardRef.current.sourceId === Number(source.id) &&
                now - duplicateGuardRef.current.ts < 500
            ) {
                return;
            }
            duplicateGuardRef.current = { sourceId: Number(source.id), ts: now };

            const { newId, clonedDatastream, clonedRanges } = buildDuplicateDatastreamDraft({
                source,
                existing,
                payloadOrId,
                templateEvaluationData,
                getNextDatastreamId,
            });

            setDetails(prev => {
                const current = (prev?.datastreams || []).filter(Boolean);
                if (current.some(ds => Number(ds.id) === Number(newId))) {
                    return prev;
                }
                return {
                    ...prev,
                    datastreams: [...current, clonedDatastream],
                };
            });

            setTemplateEvaluationData(prevData => {
                const keep = (prevData?.datastream_ranges || []).filter(
                    r => Number(r.datastream_id) !== Number(newId)
                );
                return {
                    ...prevData,
                    datastream_ranges: [...keep, ...clonedRanges],
                };
            });

            setEdit(prev => ({
                ...prev,
                edit: true,
                mode: 'edit',
                dataId: newId,
            }));
        } catch (e) {
            console.error('[TemplateDetails] Duplicate datastream failed:', e);
        }
    };



    const fields = [
        (edit.mode === 'edit' && (canEditDatastream || canDeleteDatastream)) ?
            {
                field: 'actions',
                headerName: t.column.actions,
                type: 'actions',
                width: 100,
                getActions: (params) => [
                    canEditDatastream ? <GridActionsCellItem
                        key="duplicate"
                        icon={<DuplicateIcon />}
                        showInMenu
                        label={(t.duplicate || 'Duplicate')}
                        onClick={(event) => {
                            event?.preventDefault?.();
                            event?.stopPropagation?.();
                            handleDuplicateDatastream(params.row.id);
                        }}
                    /> : null,
                    canDeleteDatastream ? <GridActionsCellItem
                        key="delete"
                        icon={<DeleteIcon />}
                        showInMenu
                        label={t.delete}
                        onClick={(event) => {
                            event?.preventDefault?.();
                            event?.stopPropagation?.();
                            setDetails(prev => ({
                                ...prev,
                                datastreams: removeDatastreamById(prev.datastreams, params.row.id)
                            }));
                            setTemplateEvaluationData(prevData => ({
                                ...prevData,
                                datastream_ranges: removeEvaluationRangesByDatastreamId(prevData.datastream_ranges, params.row.id)
                            }));
                        }}
                    /> : null,
                ].filter(Boolean),
            } : buildDisabledActionsColumn(t.column.actions),
        {
            field: 'id',
            headerName: t.column.id,
            width: 100,
            align: 'left',
            headerAlign: 'left',
            type: 'number',
            renderCell: (params) => formatDatastreamIdForDisplay(params.row.id),
        },
        { field: 'name', headerName: t.column.name, width: 200, align: 'left', headerAlign: 'left' },
        { field: 'alias', headerName: t.column.alias, width: 200, align: 'center', headerAlign: 'center' },
        {
            field: 'color', headerName: t.column.color, align: 'center',
            headerAlign: 'center', renderCell: (params) => {
                return <TemplateColorSwatchCell color={params.row.color} />;
            },
        },
        { field: 'pin', headerName: t.column.pin, width: 150, align: 'center', headerAlign: 'center' },
        { field: 'dataType', headerName: t.column.datatype, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'unit', headerName: t.column.unit, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'reportPriority', headerName: t.column.reportPriority || 'Report Priority', width: 140, type: 'number', align: 'center', headerAlign: 'center' },
        { field: 'isRaw', headerName: t.column.israw, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'min', headerName: t.column.min, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'max', headerName: t.column.max, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'decimals', headerName: t.column.decimals, width: 100, align: 'center', headerAlign: 'center' },
        { field: 'defaultValue', headerName: t.column.defaultvalue, width: 100, align: 'center', headerAlign: 'center' },
        {
            field: 'condition', headerName: t.column.condition, width: 100, align: 'center',
            headerAlign: 'center', renderCell: (params) => {

                return <TemplateBooleanToggleCell checked={params.row.condition} inactiveColor={colors.cellColor} />;
            },
        },
        {
            field: 'action', headerName: t.column.action, width: 100, align: 'center',
            headerAlign: 'center', renderCell: (params) => {

                return <TemplateBooleanToggleCell checked={params.row.action} inactiveColor={colors.cellColor} />;
            },
        },
        {
            field: 'isControlled', headerName: t.column.isControlled || 'Controlled', width: 120, align: 'center',
            headerAlign: 'center', renderCell: (params) => {

                return <TemplateBooleanToggleCell checked={params.row.isControlled} inactiveColor={colors.cellColor} />;
            },
        },
        
    ];

    const handleRowClick = (params) => {
        setEdit((prev) => ({ ...prev, ...buildDatastreamEditState(params.row.id) }));
    };

    const eventRowClick = (params) => {
        setEdit((prev) => ({ ...prev, ...buildEventEditState(params.row.id) }));
    };

    const [selectedDatastreamRows, setSelectedDatastreamRows] = useState([]);
    const [selectedEventRows, setSelectedEventRows] = useState([]);

    const handleMultiDelete = (ids) => {
        setDetails(prev => buildDatastreamBulkDeleteDetails(prev, ids));
        setTemplateEvaluationData(prevData => buildDatastreamBulkDeleteEvaluationData(prevData, ids));
        setSelectedDatastreamRows([]);
    };
    const selectActions = buildTemplateSelectedRowActions({
        canDeleteTemplate,
        deleteLabel: t.delete,
        onDelete: handleMultiDelete,
    });
    const tabs = useMemo(() => buildTemplateDetailsTabs({
        labels: t.tabs,
        icons: {
            home: <HomeIcon />,
            datastreams: <DatastreamsIcon />,
            webdashboard: <WebDashboardIcon />,
            eventsnotifications: <EventNotificationIcon />,
        },
        canViewDatastreams,
        canViewEvents,
    }), [t.tabs, canViewDatastreams, canViewEvents]);


    const [currentTab, setCurrentTab] = useState(() => {
        return parseTemplateDetailsUrlIndex(searchParams.get('tab'));
    });

    const [currentDashboard, setCurrentDashboard] = useState(() => {
        return parseTemplateDetailsUrlIndex(searchParams.get('dashboardIdx'));
    });

    const registerFixedWidthToggleHandler = useCallback((handler) => {
        if (typeof handler === 'function') {
            if (fixedWidthToggleHandlerRef.current === handler) return;
            fixedWidthToggleHandlerRef.current = handler;
            setIsFixedWidthToggleReady((prev) => prev || true);
            return;
        }

        if (fixedWidthToggleHandlerRef.current === null) return;
        fixedWidthToggleHandlerRef.current = null;
        setIsFixedWidthToggleReady((prev) => prev && false);
    }, []);

    const handleFixedWidthDashboardToggle = useCallback((nextChecked) => {
        if (typeof fixedWidthToggleHandlerRef.current === 'function') {
            fixedWidthToggleHandlerRef.current(nextChecked);
        }
    }, []);

    const handleFixedWidthStateChange = useCallback((nextChecked) => {
        setIsCurrentDashboardFixedWidth((prev) => (prev === nextChecked ? prev : nextChecked));
    }, []);

    const registerMultiSelectToggleHandler = useCallback((handler) => {
        if (typeof handler === 'function') {
            if (multiSelectToggleHandlerRef.current === handler) return;
            multiSelectToggleHandlerRef.current = handler;
            setIsMultiSelectToggleReady((prev) => prev || true);
            return;
        }

        if (multiSelectToggleHandlerRef.current === null) return;
        multiSelectToggleHandlerRef.current = null;
        setIsMultiSelectToggleReady((prev) => prev && false);
    }, []);

    const handleMultiSelectDashboardToggle = useCallback((nextChecked) => {
        if (typeof multiSelectToggleHandlerRef.current === 'function') {
            multiSelectToggleHandlerRef.current(nextChecked);
        }
    }, []);

    const handleMultiSelectStateChange = useCallback((nextChecked) => {
        setIsMultiSelectEnabled((prev) => (prev === nextChecked ? prev : nextChecked));
    }, []);

    useEffect(() => {
        const nextFixedWidth = getEffectiveFixedWidthValue(details?.webdashboard?.[currentDashboard]);
        setIsCurrentDashboardFixedWidth((prev) => (prev === nextFixedWidth ? prev : nextFixedWidth));
    }, [details?.webdashboard, currentDashboard]);

    const canReorderDashboardTabs = useMemo(() => {
        if (typeof window === 'undefined') {
            return false;
        }

        const hasCoarsePointer =
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(pointer: coarse)').matches;
        const touchPoints =
            typeof navigator !== 'undefined'
                ? Number(navigator.maxTouchPoints || 0)
                : 0;

        return !hasCoarsePointer && touchPoints === 0;
    }, []);


    const [addDashboard, setAddDashboard] = useState({
        adding: false,
        dashboardName: 'Dashboard',
        dashboardRoles: ['super', 'owner'],
        dashboardLayoutMode: WEB_DASHBOARD_LAYOUT_MODES.PIXELS,
    });
    const [editingTabRoleData, setEditingTabRoleData] = useState(null);

    const [editPopupAnchor, setEditPopupAnchor] = useState(null);
    const [addPopupAnchor, setAddPopupAnchor] = useState(null);

    const editPopupRef = useRef(null);
    const addPopupRef = useRef(null);
    const editTriggerRef = useRef(null);
    const addTriggerRef = useRef(null);

    const handleEditTabRoleSelection = useCallback((role) => {
        setEditingTabRoleData(prev => {
            return toggleDashboardAccessRoleState(prev, role, 'roles');
        });
    }, []);

    const handleEditTabNameChange = useCallback((value) => {
        setEditingTabRoleData(prev => {
            if (!prev) return prev;
            return { ...prev, name: value };
        });
    }, []);

   const saveEditedTabRoles = () => {
        if (!editingTabRoleData) return;

        setDetails(prevDetails => applyEditedDashboardTabRoles(prevDetails, editingTabRoleData));

        setEditingTabRoleData(null);
        setEditPopupAnchor(null);
    };

    


    const handleRoleSelection = (role) => {
        setAddDashboard(prev => {
            return toggleDashboardAccessRoleState(prev, role, 'dashboardRoles');
        });
    };


    const {
        isWebDashboardTabActive,
        isDashboardExpandedActive,
        effectiveDetailsRailExpanded,
        dashboardMaxHeight,
        dashboardExpandLabel,
    } = buildTemplateDashboardViewportState({
        tabs,
        currentTab,
        webDashboardTabName: t.tabs.webdashboard,
        details,
        isDashboardExpanded,
        isDetailsRailExpanded,
        dashboardViewportHeight,
        viewportHeight: dims.height,
        editMode: edit.mode,
        labels: {
            collapseAction: webDashboardT.collapseAction || t.collapseAction,
            expandAction: webDashboardT.expandAction || t.expandAction,
        },
    });

    const updateDashboardViewportHeight = useCallback(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const panelElement = dashboardBodyRef.current;
        const viewportElement = dashboardViewportRef.current;

        if (!panelElement || !viewportElement) {
            setDashboardViewportHeight(null);
            return;
        }

        const panelRect = panelElement.getBoundingClientRect();
        const viewportRect = viewportElement.getBoundingClientRect();
        const spacing = 8;
        const nextHeight = Math.floor(panelRect.bottom - viewportRect.top - spacing);

        if (!Number.isFinite(nextHeight) || nextHeight <= 0) {
            setDashboardViewportHeight(null);
            return;
        }

        setDashboardViewportHeight((prev) => (prev === nextHeight ? prev : nextHeight));
    }, []);

    useEffect(() => {
        if (!isWebDashboardTabActive) {
            setDashboardViewportHeight(null);
            setIsDashboardExpanded(false);
            return undefined;
        }

        if (typeof window === 'undefined') {
            return undefined;
        }

        let rafId = 0;
        const scheduleViewportMeasure = () => {
            if (rafId) {
                window.cancelAnimationFrame(rafId);
            }

            rafId = window.requestAnimationFrame(() => {
                updateDashboardViewportHeight();
            });
        };

        scheduleViewportMeasure();

        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', scheduleViewportMeasure);

            return () => {
                if (rafId) {
                    window.cancelAnimationFrame(rafId);
                }
                window.removeEventListener('resize', scheduleViewportMeasure);
            };
        }

        const resizeObserver = new ResizeObserver(() => {
            scheduleViewportMeasure();
        });

        [dashboardBodyRef.current, dashboardViewportRef.current]
            .filter(Boolean)
            .forEach((element) => resizeObserver.observe(element));

        window.addEventListener('resize', scheduleViewportMeasure);

        return () => {
            if (rafId) {
                window.cancelAnimationFrame(rafId);
            }
            resizeObserver.disconnect();
            window.removeEventListener('resize', scheduleViewportMeasure);
        };
    }, [
        isWebDashboardTabActive,
        currentDashboard,
        edit.mode,
        isDashboardExpandedActive,
        updateDashboardViewportHeight,
    ]);


    function moveBorder(className, originalIndex) { 
        const border = document.querySelector('.' + className + '-tab-border');
        const targetTab = document.querySelector(`.${className}-tab[data-original-index="${originalIndex}"]`);

        if (border && targetTab) { 
            const dashboardWidth = document.defaultView.getComputedStyle(targetTab).width;
            border.style.width = dashboardWidth;
            border.style.left = targetTab.offsetLeft + 'px';
            targetTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    }

    const fetchTemplate = useCallback(async () => {
        if (!id) return;
        setLoading(true);
        try {
            const res = await axios.get(apiUrl(`template/get/${id}`));

            if (res.data && res.data.status === 'OK') {
                const { hydrated, evaluationData } = hydrateFetchedTemplateDetails(res.data.data);
                setTemplateEvaluationData(evaluationData);

                setDetails(deepClone(hydrated));
                setInitialTemplate(deepClone(hydrated));
            } else {
                throw new Error('Received an invalid response from the server.');
            }
        } catch (err) {
            console.error("Failed to fetch template:", err);
            const errorMessage = getErrorMessage(err);
            showAlert('error', `${t.loadTemplateError || 'Could not load template:'} ${errorMessage}`);
            setDetails(null);
            setInitialTemplate(null);
        } finally {
            setLoading(false);
        }
    }, [
        id,
        showAlert,
        t.loadTemplateError,
    ]);


    

    useEffect(() => {
        if (!details?.webdashboard || details.webdashboard.length === 0) {
            if (currentDashboard !== 0) setCurrentDashboard(0);
            if (searchParams.get('dashboardIdx') !== '0') setSearchParams(prev => { prev.set('dashboardIdx', '0'); return prev; }, { replace: true });
            return;
        }

        const currentDashboardData = details.webdashboard[currentDashboard];
        const isCurrentValid = currentDashboardData && checkTabPermission(userRole, currentDashboardData.access_role);

        let newDashboardIndex = currentDashboard;
        if (!isCurrentValid) {
            const firstViewableIndex = details.webdashboard.findIndex((wd) =>
                checkTabPermission(userRole, wd.access_role)
            );
            newDashboardIndex = firstViewableIndex !== -1 ? firstViewableIndex : 0; 
        }

        if (newDashboardIndex !== currentDashboard) {
            setCurrentDashboard(newDashboardIndex);
            setSearchParams(prev => { prev.set('dashboardIdx', newDashboardIndex.toString()); return prev; }, { replace: true });
        } else {
            const dashboardIdxFromUrl = parseInt(searchParams.get('dashboardIdx'));
            if (isNaN(dashboardIdxFromUrl) || dashboardIdxFromUrl !== currentDashboard) {
                 setSearchParams(prev => { prev.set('dashboardIdx', currentDashboard.toString()); return prev; }, { replace: true });
            }
        }
    }, [details?.webdashboard, userRole, currentDashboard, searchParams, setSearchParams]);


    useEffect(() => {
        if (tabs[currentTab]?.name === t.tabs.webdashboard) {
            setTimeout(() => {
                moveBorder('dashboard', currentDashboard);
            }, 0);
        }
    }, [currentDashboard, currentTab, tabs, t.tabs.webdashboard]);

    useEffect(() => {
        fetchTemplate();
    }, [fetchTemplate]);


    const duplicateTemplate = async () => {
        if (!canAddTemplate) {
            showAlert('error', t.actionPermissionError || 'You do not have permission to perform this action.');
            return;
        }
        if (loading || !initialTemplate) {
            showAlert('warning', t.duplicateMissingTemplate || 'Cannot duplicate because the initial template data is missing.');
            return;
        }
        setLoading(true);

        try {
            const { id, tid, name, device_count, datastreams, events, webdashboard, mobdashboard, templateEvaluationData: oldEvalsData, ...rest } = initialTemplate;

            const body = { name: `${name}-Copy` };

            Object.keys(rest).forEach(key => {
                if (rest[key] !== null && rest[key] !== undefined) {
                    body[key] = rest[key];
                }
            });

            body.datastreams = datastreams || [];
            body.events = events || [];
            body.webdashboard = webdashboard || []; 
            body.mobdashboard = mobdashboard || [];
            
            if (oldEvalsData && oldEvalsData.evaluation_names) {
                body.templateEvaluationData = {
                    evaluation_names: oldEvalsData.evaluation_names.map(e => ({
                        name: e.name,
                        priority: e.priority,
                        color: e.color,
                        colorLight: e.colorLight ?? e.color_light ?? null
                    })), 
                    datastream_ranges: (oldEvalsData.datastream_ranges || []).map(r => ({
                        datastream_id: r.datastream_id,
                        name: oldEvalsData.evaluation_names.find(n => n.template_datastream_evaluation_id === r.template_datastream_evaluation_id)?.name, 
                        from_value: r.from_value,
                        to_value: r.to_value
                    })).filter(r => r.name) 
                };
            }


            const res = await axios.post(
                apiUrl(`template/create`),
                body,
                { headers: { "Content-Type": 'application/json' } }
            );

            if (res.status === 201 && res.data.status === 'OK') {
                showAlert('success', t.templateDuplicated || 'Template duplicated successfully.');
                navigate(`/configuration/templates/details/${res.data.data.id}`);
            } else {
                throw new Error(t.unexpectedResponse || "Received an unexpected response from the server.");
            }
        } catch (err) {
            const errorMessage = getErrorMessage(err);
            showAlert('error', errorMessage);
        } finally {
            setLoading(false);
        }
    };

const fileActionMessages = buildTemplateFileActionMessages(t);

const deleteFilesBulk = (files, alertHandler) =>
    deleteTemplateFilesBulk(files, alertHandler, fileActionMessages);

const deleteFile = (fileName, alertHandler) =>
    deleteTemplateFile(fileName, alertHandler, fileActionMessages);

const saveFile = (file, alertHandler, prefix) =>
    saveTemplateFile(file, alertHandler, fileActionMessages, prefix);

const updateTemplate = async (e) => {
        if (!canEditTemplate) {
            showAlert("error", t.actionPermissionError || "You do not have permission to perform this action.");
            return;
        }
        const triggerElement = e?.currentTarget || e?.target || null;
        const isTriggerDisabled = Boolean(
            triggerElement?.classList?.contains("disabled") || triggerElement?.disabled
        );

        if (isApplyDisabled || isTriggerDisabled || loading) {
            return;
        }

        const datastreamValidation = validateDatastreamCollection(
            details?.datastreams || [],
            buildDatastreamValidationOptions(t, DATASTREAM_MIN_MAX_ABS_LIMIT)
        );

        if (!datastreamValidation.valid) {
            showAlert("error", datastreamValidation.message);
            return;
        }

        const datastreamTypeChanges = findDatastreamTypeChangesForConfirmation(
            initialTemplate?.datastreams,
            details?.datastreams
        );

        if (datastreamTypeChanges.length > 0) {
            const confirmed = await alert(
                buildDatastreamTypeChangeConfirmation(t, datastreamTypeChanges)
            );

            if (!confirmed) {
                return;
            }
        }

setLoading(true);

        let uploadedMapIcon = null;

        try {
            const payload = await uploadWidgetsFiles();
            const removedFiles = diffRemovedFiles(initialTemplate, payload);
            const { finalPayload, datastreamsPatch } = buildTemplateUpdatePayloadBase({
                payload,
                initialTemplate,
                templateEvaluationData,
            });

            const previousMapIcon = normalizeStoredIconPath(initialTemplate?.map_icon);
            if (pendingMapIconFile) {
                uploadedMapIcon = await uploadTemplateMapIcon(
                    pendingMapIconFile,
                    finalPayload.name || details?.name || 'template'
                );
                finalPayload.map_icon = uploadedMapIcon;
            } else if (mapIconMarkedForRemoval) {
                finalPayload.map_icon = null;
            }

            delete finalPayload.mobdashboard;
            delete finalPayload.datastreams;

            if (hasDatastreamPatchChanges(datastreamsPatch)) {
                finalPayload.datastreamsPatch = datastreamsPatch;
            }
            if (reportPriorityChanges.length > 0) {
                finalPayload.reportPriorityChange = reportPriorityChanges;
            }

            const res = await axios.put(
                apiUrl(`template/update/${id}`),
                finalPayload,
                { headers: { "Content-Type": "application/json", "X-Client-Platform": "web" } }
            );

            if (res.status === 200 && res.data.status === "OK") {
                await cleanupPreviousTemplateIcon(previousIcon, deleteFilesBulk, showAlert);

                if (removedFiles.length > 0) {
                    await deleteFilesBulk(removedFiles, showAlert);
                }

                const nextMapIcon = normalizeStoredIconPath(finalPayload.map_icon);
                await cleanupPreviousTemplateMapIcon({
                    previousMapIcon,
                    nextMapIcon,
                    pendingMapIconFile,
                    mapIconMarkedForRemoval,
                    deleteStoredMapIcon,
                });

                clearPendingMapIconPreview();
                setPendingMapIconFile(null);
                setMapIconMarkedForRemoval(false);

                showAlert(
                    "success",
                    res.data.datastreamCleanup?.message ||
                    res.data.message ||
                    t.templateUpdated ||
                    "Template updated successfully."
                );

                const originDevicePath = getOriginDevicePath(origin, originDeviceId);
                if (originDevicePath) {
                    navigate(originDevicePath);
                    return;
                } else {
                    setEdit((prev) => ({ ...prev, mode: "view" }));
                    const responseData = res.data.data;
                    const safeUpdatedDetails = deepClone(
                        hydrateTemplateDetailsResponse(responseData, details)
                    );
                    setDetails(safeUpdatedDetails);
                    setInitialTemplate(deepClone(safeUpdatedDetails));
                    setReportPriorityChanges([]);
                    setTemplateEvaluationData(responseData.templateEvaluationData || { evaluation_names: [], datastream_ranges: [] });
                }
            } else {
                throw new Error("Received an unexpected response from the server.");
            }
        } catch (err) {
            console.error("Template update failed:", err);
            await cleanupUploadedMapIconAfterFailure(uploadedMapIcon, deleteStoredMapIcon);
            if (!err.isUploadError) {
                const errorMessage = getErrorMessage(err);
                showAlert("error", errorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

const uploadWidgetsFiles = async () => {
    return uploadTemplateWidgetFiles(details, {
        deleteFile,
        saveFile,
        showAlert,
        fileSaveError: t.fileSaveError,
    });
};

const handleCancelEdit = async () => {
        const confirmed = await alert({
            type: 'confirm',
            variant: 'danger',
            icon: 'alert',
            title: t.confirmTitle || 'Confirm',
            message: t.leaveWithoutSaving,
            confirmText: t.buttonOk || templateTranslations[lang].buttonOk || 'OK',
            cancelText: t.cancel || templateTranslations[lang].buttonCancel || 'Cancel',
            showCancel: true,
        });

        if (!confirmed) {
            return;
        }

        if (details && initialTemplate) {
            await cleanupOrphanedTemplateIcon(details, initialTemplate);
        }

        const originDevicePath = getOriginDevicePath(origin, originDeviceId);
        if (originDevicePath) {
            navigate(originDevicePath);
            return;
        } else {
            setEdit(prev => ({ ...prev, mode: 'view' }));
            clearPendingMapIconPreview();
            setPendingMapIconFile(null);
            setMapIconMarkedForRemoval(false);
            setReportPriorityChanges([]);
            setDetails(initialTemplate);
            setTemplateEvaluationData(
                initialTemplate.templateEvaluationData || {
                    evaluation_names: [],
                    datastream_ranges: []
                }
            );
        }
    };


    const size = { width: '100%', height: '60vh' };
    const isApplyDisabled = useMemo(() => {
        if (!details || !initialTemplate) {
            return true;
        }

        const initialEvaluationData = initialTemplate.templateEvaluationData || {
            evaluation_names: [],
            datastream_ranges: []
        };

        return (
            JSON.stringify(details) === JSON.stringify(initialTemplate) &&
            JSON.stringify(templateEvaluationData) === JSON.stringify(initialEvaluationData) &&
            !pendingMapIconFile &&
            !mapIconMarkedForRemoval
        );
    }, [details, initialTemplate, mapIconMarkedForRemoval, pendingMapIconFile, templateEvaluationData]);

useEffect(() => {
        const onPointerDown = (e) => {
            const target = e.target;

            if (editingTabRoleData) {
                const clickedInsideEdit =
                    editPopupRef.current && editPopupRef.current.contains(target);
                const clickedEditTrigger =
                    editTriggerRef.current && editTriggerRef.current.contains(target);

                if (!clickedInsideEdit && !clickedEditTrigger) {
                    setEditingTabRoleData(null);
          setEditPopupAnchor(null);
                    setEditPopupAnchor(null);
                }
            }

            if (addDashboard.adding) {
                const clickedInsideAdd =
                    addPopupRef.current && addPopupRef.current.contains(target);
                const clickedAddTrigger =
                    addTriggerRef.current && addTriggerRef.current.contains(target);

                if (!clickedInsideAdd && !clickedAddTrigger) {
                    setAddDashboard({
                        adding: false,
                        dashboardName: 'Dashboard',
                        dashboardRoles: ['super', 'owner'],
                        dashboardLayoutMode: WEB_DASHBOARD_LAYOUT_MODES.PIXELS,
                    });
                    setAddPopupAnchor(null);
                }
            }
        };

        window.addEventListener('pointerdown', onPointerDown, true);
        return () => window.removeEventListener('pointerdown', onPointerDown, true);
    }, [editingTabRoleData, addDashboard.adding]);


    return (canViewTemplate ?
        loading ? <Spinner /> :
            details?.id ?
                <Fragment>
                    <Alert
                        open={alertState.open}
                        close={() => setAlertState({ ...alertState, open: false })}
                        message={alertState.message}
                        type={alertState.type}
                        position={alertState.position}
                    />
                    <AppDialog
                        open={dialog.open}
                        type={dialog.type}
                        variant={dialog.variant}
                        icon={dialog.icon}
                        title={dialog.title}
                        message={dialog.message}
                        confirmText={dialog.confirmText}
                        cancelText={dialog.cancelText}
                        showCancel={dialog.showCancel}
                        onConfirm={() => closeDialog(true)}
                        onCancel={() => closeDialog(false)}
                        onClose={() => closeDialog(false)}
                    />

                    <TemplateExampleDialogs
                        t={t}
                        isRtl={isRtl}
                        markAsExampleDialog={markAsExampleDialog}
                        closeMarkAsExampleDialog={closeMarkAsExampleDialog}
                        handleMarkAsExampleNameChange={handleMarkAsExampleNameChange}
                        submitMarkAsExample={submitMarkAsExample}
                        isMarkAsExampleSubmitDisabled={isMarkAsExampleSubmitDisabled}
                        isExampleNameDuplicate={isExampleNameDuplicate}
                        loadingTemplateExamples={loadingTemplateExamples}
                        attachExampleDialog={attachExampleDialog}
                        closeAttachExampleDialog={closeAttachExampleDialog}
                        attachedTemplateExample={attachedTemplateExample}
                        attachExampleOptions={attachExampleOptions}
                        selectedAttachExampleOption={selectedAttachExampleOption}
                        handleAttachExampleSelection={handleAttachExampleSelection}
                        submitAttachExample={submitAttachExample}
                        templateExampleSelectStyles={templateExampleSelectStyles}
                    />

                    <TemplateEditTabRolePopup
                        t={t}
                        lang={lang}
                        editingTabRoleData={editingTabRoleData}
                        editPopupAnchor={editPopupAnchor}
                        editPopupRef={editPopupRef}
                        details={details}
                        currentDashboard={currentDashboard}
                        allRoles={allRoles}
                        webDashboardT={webDashboardT}
                        alert={alert}
                        setDetails={setDetails}
                        setEditingTabRoleData={setEditingTabRoleData}
                        setEditPopupAnchor={setEditPopupAnchor}
                        setCurrentDashboard={setCurrentDashboard}
                        setSearchParams={setSearchParams}
                        handleEditTabNameChange={handleEditTabNameChange}
                        handleEditTabRoleSelection={handleEditTabRoleSelection}
                        saveEditedTabRoles={saveEditedTabRoles}
                    />

                    <TemplateAddDashboardPopup
                        t={t}
                        addDashboard={addDashboard}
                        addPopupAnchor={addPopupAnchor}
                        addPopupRef={addPopupRef}
                        allRoles={allRoles}
                        webDashboardT={webDashboardT}
                        details={details}
                        setAddDashboard={setAddDashboard}
                        setAddPopupAnchor={setAddPopupAnchor}
                        handleRoleSelection={handleRoleSelection}
                        setDetails={setDetails}
                        setCurrentDashboard={setCurrentDashboard}
                        setSearchParams={setSearchParams}
                    />

                    <TemplateDeviceEvaluationModals
                        addDevice={addDevice}
                        fetchTemplate={fetchTemplate}
                        setAddDevice={setAddDevice}
                        details={details}
                        isEvalModalOpen={isEvalModalOpen}
                        canEditTemplate={canEditTemplate}
                        setIsEvalModalOpen={setIsEvalModalOpen}
                        templateEvaluationData={templateEvaluationData}
                        setTemplateEvaluationData={setTemplateEvaluationData}
                    />

                    <div className='details-container' dir={isRtl ? 'rtl' : 'ltr'}>
                        <TemplateEditorModals
                            edit={edit}
                            setEdit={setEdit}
                            addDatastream={addDatastream}
                            setAddDatastream={setAddDatastream}
                            details={details}
                            setDetails={setDetails}
                            canEditEvent={canEditEvent}
                            canEditDatastream={canEditDatastream}
                            templateEvaluationData={templateEvaluationData}
                            setTemplateEvaluationData={setTemplateEvaluationData}
                            getNextDatastreamId={getNextDatastreamId}
                            downloadReportState={downloadReportState}
                            setDownloadReportState={setDownloadReportState}
                            setLoading={setLoading}
                            showAlert={showAlert}
                            reportPriorityPolicy={reportPriorityPolicy}
                            onReportPriorityChange={(change) => setReportPriorityChanges((previous) => [
                                ...previous,
                                change,
                            ])}
                        />
<TemplateDetailsControlRail
    t={t}
    tabs={tabs}
    currentTab={currentTab}
    currentDashboard={currentDashboard}
    isMobileTemplateDetailsLayout={isMobileTemplateDetailsLayout}
    isMobileDetailsRailOpen={isMobileDetailsRailOpen}
    effectiveDetailsRailExpanded={effectiveDetailsRailExpanded}
    navigate={navigate}
    setTabsWidth={setTabsWidth}
    setCurrentTab={setCurrentTab}
    setSearchParams={setSearchParams}
    setEditingTabRoleData={setEditingTabRoleData}
    setIsMobileDetailsRailOpen={setIsMobileDetailsRailOpen}
/>

                        <TemplateDetailsContentShell
                            t={t}
                            details={details}
                            edit={edit}
                            loading={loading}
                            alert={alert}
                            navigate={navigate}
                            isWebDashboardTabActive={isWebDashboardTabActive}
                            isDashboardExpandedActive={isDashboardExpandedActive}
                            isMobileTemplateDetailsLayout={isMobileTemplateDetailsLayout}
                            setIsMobileDetailsRailOpen={setIsMobileDetailsRailOpen}
                            canOpenReportDialog={canOpenReportDialog}
                            canAddTemplate={canAddTemplate}
                            canAddTemplateExamples={canAddTemplateExamples}
                            isCompactHeaderActions={isCompactHeaderActions}
                            isHeaderActionsMenuOpen={isHeaderActionsMenuOpen}
                            setIsHeaderActionsMenuOpen={setIsHeaderActionsMenuOpen}
                            headerActionsMenuRef={headerActionsMenuRef}
                            downloadReportActionLabel={downloadReportActionLabel}
                            setDownloadReportState={setDownloadReportState}
                            duplicateTemplate={duplicateTemplate}
                            openMarkAsExampleDialog={openMarkAsExampleDialog}
                            handleCancelEdit={handleCancelEdit}
                            isApplyDisabled={isApplyDisabled}
                            updateTemplate={updateTemplate}
                            setEdit={setEdit}
                            dashboardBodyRef={dashboardBodyRef}
                        >
                                    {tabs[currentTab].name === t.tabs.datastreams ?
                                        <TemplateDatastreamsTab
                                            details={details}
                                            setDetails={setDetails}
                                            edit={edit}
                                            setEdit={setEdit}
                                            addDatastream={addDatastream}
                                            setAddDatastream={setAddDatastream}
                                            templateEvaluationData={templateEvaluationData}
                                            setTemplateEvaluationData={setTemplateEvaluationData}
                                            isEvalModalOpen={isEvalModalOpen}
                                            setIsEvalModalOpen={setIsEvalModalOpen}
                                            canEditTemplate={canEditTemplate}
                                            canEditDatastream={canEditDatastream}
                                            canDeleteDatastream={canDeleteDatastream}
                                            t={t}
                                            pagingoptions={pagingoptions}
                                            colors={colors}
                                            handleRowClick={handleRowClick}
                                            selectedRows={selectedDatastreamRows}
                                            setSelectedRows={setSelectedDatastreamRows}
                                            selectActions={selectActions}
                                            size={size}
                                            pinCategories={pinCategories}
                                            fields={fields}
                                        /> :
                                        (tabs[currentTab].name === t.tabs.webdashboard && details.webdashboard && details.webdashboard.length > 0 ?
                                            <TemplateDashboardTabPanel
                                                dashboardPanelRef={dashboardPanelRef}
                                                dashboardViewportRef={dashboardViewportRef}
                                                t={t}
                                                details={details}
                                                edit={edit}
                                                userRole={userRole}
                                                currentDashboard={currentDashboard}
                                                setCurrentDashboard={setCurrentDashboard}
                                                setSearchParams={setSearchParams}
                                                setDetails={setDetails}
                                                editingTabRoleData={editingTabRoleData}
                                                setEditingTabRoleData={setEditingTabRoleData}
                                                editTriggerRef={editTriggerRef}
                                                setEditPopupAnchor={setEditPopupAnchor}
                                                addTriggerRef={addTriggerRef}
                                                setAddPopupAnchor={setAddPopupAnchor}
                                                setAddDashboard={setAddDashboard}
                                                canReorderDashboardTabs={canReorderDashboardTabs}
                                                isDashboardExpandedActive={isDashboardExpandedActive}
                                                webDashboardT={webDashboardT}
                                                isMultiSelectEnabled={isMultiSelectEnabled}
                                                handleMultiSelectDashboardToggle={handleMultiSelectDashboardToggle}
                                                isMultiSelectToggleReady={isMultiSelectToggleReady}
                                                isCurrentDashboardFixedWidth={isCurrentDashboardFixedWidth}
                                                handleFixedWidthDashboardToggle={handleFixedWidthDashboardToggle}
                                                isFixedWidthToggleReady={isFixedWidthToggleReady}
                                                setIsDashboardExpanded={setIsDashboardExpanded}
                                                dashboardExpandLabel={dashboardExpandLabel}
                                                dashboardMaxHeight={dashboardMaxHeight}
                                                handleFixedWidthStateChange={handleFixedWidthStateChange}
                                                registerFixedWidthToggleHandler={registerFixedWidthToggleHandler}
                                                handleMultiSelectStateChange={handleMultiSelectStateChange}
                                                registerMultiSelectToggleHandler={registerMultiSelectToggleHandler}
                                            /> :
                                            tabs[currentTab].name === t.tabs.eventsnotifications
                                                ? <TemplateEventsTab
                                                    details={details}
                                                    setAddDatastream={setAddDatastream}
                                                    edit={edit}
                                                    canEditEvent={canEditEvent}
                                                    t={t}
                                                    eventsFields={eventsFields}
                                                    pagingoptions={pagingoptions}
                                                    eventRowClick={eventRowClick}
                                                    selectedRows={selectedEventRows}
                                                    setSelectedRows={setSelectedEventRows}
                                                    selectActions={selectActions}
                                                    size={size}
                                                />
                                                : (tabs[currentTab].name === t.tabs.home ?
                                                    <TemplateHomeTab
                        details={details}
                        setDetails={setDetails}
                        edit={edit}
                        setEdit={setEdit}
                        canEditTemplate={canEditTemplate}
                        canAddTemplate={canAddTemplate}
                        canProvisionDevices={canProvisionDevices}
                        canDeleteTemplate={canDeleteTemplate}
                        canDownloadReports={canOpenReportDialog}
                        settings={settings}
                        setSettings={setSettings}
                        previousIcon={previousIcon}
                        setPreviousIcon={setPreviousIcon}
                        downloadReportState={downloadReportState}
                        setDownloadReportState={setDownloadReportState}
                        t={t}
                        isRtl={isRtl}
                        navigate={navigate}
                        updateTemplate={updateTemplate}
                        handleCancelEdit={handleCancelEdit}
                        onOpenAddDevice={() => setAddDevice(true)}
                        canManageTemplateExampleLinks={canManageTemplateExampleLinks}
                        onOpenAttachExampleDialog={openAttachExampleDialog}
                        onDetachTemplateFromExample={detachTemplateFromExample}
                        pendingMapIconPreviewUrl={pendingMapIconPreviewUrl}
                        pendingMapIconFile={pendingMapIconFile}
                        onMapIconFileChange={handleMapIconFileChange}
                        onRemoveMapIcon={handleRemoveMapIcon}
                    />
                                                    : <TemplateFallbackTabContent
                                                        tabName={tabs[currentTab].name}
                                                        tabLabel={t.tabLabel}
                                                    />
                                                ))}
                        </TemplateDetailsContentShell>
                    </div > </Fragment> : <div style={{
                        width: '100%', height: '100%', display: "flex",
                        alignItems: "center", justifyContent: "center"
                    }}>{templateTranslations[lang].noData}</div>
        : <div>{templateTranslations[lang].noPermission}</div>);
};
